import classNames from 'classnames';
import React from 'react';
import AnimateHeight from 'react-animate-height';
import ChevronDownIcon from 'ui/Icons/tabler/chevron-down.component.svg';
import { SvgIcon } from 'ui/SvgIcon';

export interface IAccordionStackableProps {
  summary?: React.ReactNode;
  renderSummary?: ({ isOpen }: { isOpen: boolean }) => React.ReactNode;
  children: React.ReactNode;
  isOpen?: boolean;
  onToggle?: (newIsOpen: boolean) => void;
  shouldAnimateHeight?: boolean;
  chevronPosition?: 'none' | 'left' | 'right';
  wrapperClassName?: string;
  buttonClassName?: string;
  contentWrapperClassName?: string;
  summaryPrefixDom?: React.ReactNode;
}

/**
 *
 * @param props.children ensure that your children props don't have any margin on, or it breaks the styles. Blame CSS.
 */
export const AccordionStackable = (props: IAccordionStackableProps) => {
  const { isOpen = false, shouldAnimateHeight = true, chevronPosition = 'right' } = props;
  return (
    <div
      className={classNames(
        'accordion-stackable border-1 border-gray-20 border-solid border-b-0 last-of-type:border-b-1',
        props.wrapperClassName
      )}
    >
      <div className={classNames('flex items-center')}>
        {props.summaryPrefixDom}
        <button
          className={classNames(
            'flex items-center text-left text-black text-17px font-normal bg-white font-pt-sans w-full px-20px py-3 cursor-pointer',
            {
              'justify-between': chevronPosition === 'right',
            },
            props.buttonClassName
          )}
          onClick={e => {
            props.onToggle && props.onToggle(!isOpen);
          }}
        >
          {chevronPosition === 'left' && (
            <span className="inline-block translate-y-1px accordion-stackable-chevron mr-2">
              <SvgIcon
                IconComponent={ChevronDownIcon}
                className={classNames('w-4 fill-transparent stroke-current stroke-2 transition-transform', {
                  'rotate-180': isOpen,
                })}
              />
            </span>
          )}

          {props.summary}
          {props.renderSummary && props.renderSummary({ isOpen })}

          {chevronPosition === 'right' && (
            <span className="inline-block translate-y-1px accordion-stackable-chevron">
              <SvgIcon
                IconComponent={ChevronDownIcon}
                className={classNames('w-4 fill-transparent stroke-current stroke-2 transition-transform', {
                  'rotate-180': isOpen,
                })}
              />
            </span>
          )}
        </button>
      </div>
      <AnimateHeight duration={shouldAnimateHeight ? 100 : 0} height={isOpen ? 'auto' : 0} className="accordion-area">
        <div
          className={classNames(
            'accordion-stackable-content font-pt-sans text-black px-20px py-3',
            props.contentWrapperClassName
          )}
        >
          {props.children}
        </div>
      </AnimateHeight>
    </div>
  );
};
